<template>
    <div class="mdc-card mdc-elevation--z2 pda-default t-center t-color-content1">
        <div class="">
            <i class="material-icons t-headline3">event_busy</i>
        </div>
        <div class="mgt-8">
            No Data
        </div>
    </div>
        
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {

}
</script>
